import { Country, State, City } from "country-state-city";
import SelectOptions from "../interfaces/select-compopnent.interface";
const countries = Country.getAllCountries();

export const CountriesOpts = (): Array<SelectOptions> => {
  let newCountries = countries.map((item) => {
    return { value: item.name, label: item.name, code: item.isoCode };
  });
  return [
    { value: "0", label: "select", code: "0" },
    ...newCountries,
    { value: "other", label: "other", code: "" },
  ];
};

export const StatesOpts = (countryCode: string): Array<SelectOptions> => {
  const states = State.getStatesOfCountry(countryCode);
  if (!states.length) {
    return [];
  }
  let newStates = states.map((item) => {
    return { value: item.name, label: item.name, code: item.isoCode };
  });
  return [
    { value: "0", label: "select", code: "" },
    ...newStates,
    { value: "other", label: "other", code: "" },
  ];
};

export const CitiesOpts = (
  countryCode: string,
  stateCode: string,
): Array<SelectOptions> => {
  const cities = City.getCitiesOfState(countryCode, stateCode);
  if (!cities.length) {
    return [];
  }
  let newCity = cities.map((item) => {
    return { value: item.name, label: item.name, code: item.stateCode };
  });
  return [{ value: "0", label: "select", code: "" }, ...newCity];
};
